module.exports = __webpack_public_path__ + "img/google-calendar.819f1ade.png";